export const PageLoader = () => (
  <div className="fixed inset-0 z-[1034] pointer-events-none" role="status" aria-label="Loading">
    <div className="relative h-[3px] w-full overflow-hidden bg-primary-500/15">
      <div className="absolute inset-y-0 w-1/3 bg-primary-500 animate-[hitZak_0.6s_ease-in-out_infinite_alternate]" />
    </div>
  </div>
);

export const Skeleton = ({ w = '100%', h = '1rem', className = '' }) => (
  <span
    className={`block rounded animate-pulse bg-secondary-500/10 dark:bg-white/10 ${className}`}
    style={{ width: w, height: h }}
  />
);

export const TableSkeleton = ({ rows = 6, cols = 4 }) => (
  <tbody>
    {Array.from({ length: rows }, (_, rowIndex) => (
      <tr key={rowIndex}>
        {Array.from({ length: cols }, (_, colIndex) => (
          <td key={colIndex}>
            <Skeleton h="0.85rem" />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);
